import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const organizationTariffsUpdateFrequenciesAdapter = getAdapter({ idFieldName: 'value' });

const organizationTariffsUpdateFrequenciesSlice = createSlice({
  name: 'organizationTariffsUpdateFrequencies',
  initialState: organizationTariffsUpdateFrequenciesAdapter.getInitialState(),
  reducers: {
    setOrganizationTariffsUpdateFrequencies: (state, { payload: { organizationTariffsUpdateFrequencies } }) => {
        console.log('organizationTariffsUpdateFrequencies', organizationTariffsUpdateFrequencies)
        organizationTariffsUpdateFrequenciesAdapter.setAll(state, organizationTariffsUpdateFrequencies)
    },
  },
});

const selectors = organizationTariffsUpdateFrequenciesAdapter.getSelectors(({ organizationTariffsUpdateFrequencies }) => organizationTariffsUpdateFrequencies);

export const getOrganizationTariffsUpdateFrequencies = (state) => selectors.selectAll(state);

export const { setOrganizationTariffsUpdateFrequencies } = organizationTariffsUpdateFrequenciesSlice.actions;

export default organizationTariffsUpdateFrequenciesSlice.reducer;
